export const menu = [
  {
    id: 1,
    title: 'Главная',
    url: '/',
  },
  {
    id: 2,
    title: 'Площадки',
    url: '/arenas',
    subMenu: [
      {
        id: 1,
        title: 'Площадка на Адмиралтейской',
        url: '/arenas/Admiralteyskaya-Kazan',
      },
      {
        id: 2,
        title: 'Площадка на Дубравной',
        url: '/arenas/Dubravnaya-Kazan',
      },
      {
        id: 3,
        title: 'Площадка на Ново-Давликеевской',
        url: '/arenas/Novo-Davlikeevskaya-Kazan',
      },
      {
        id: 3,
        title: 'Площадка на Салмачи',
        url: '/arenas/Salmachi-Kazan',
      },
    ],
  },
  {
    id: 3,
    title: 'Игры',
    url: '/games',
    subMenu: [
      {
        id: 1,
        title: 'Лазертаг',
        url: '/games/Lasertag-Kazan',
      },
      {
        id: 2,
        title: 'Пейнтбол',
        url: '/games/Paintball-Kazan',
      },
      {
        id: 3,
        title: 'Гидробол',
        url: '/games/Gidroball-Kazan',
      },
    ],
  },
  {
    id: 4,
    title: 'О нас',
    url: '/игры',
    subMenu: [
      {
        id: 1,
        title: 'Контакты',
        url: '/contact',
      },
      {
        id: 2,
        title: 'Фотогалерея',
        url: '/gallery',
      },
    ],
  },
];
